import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import EmptyStateMessage from './EmptyStateMessage';
import ErrorMessageType from './ErrorMessageType';
import customErrorTypes from '../../constants/customErrorTypes';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import { AnyCrmObjectTypePropType } from 'customer-data-objects-ui-components/propTypes/CrmObjectTypes';
import emptyFunction from 'react-utils/emptyFunction';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  CONTACT_SEARCH_FILTERS
} = customErrorTypes;
const errorStateMessages = {};
errorStateMessages.generic = {
  header: 'GenericGrid.error.icecream',
  subtext: 'GenericGrid.error.subheader',
  buttonText: 'GenericGrid.error.buttonText_jsx',
  buttonHref: window.location.href,
  illustration: 'errors/general'
};

// @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
errorStateMessages[CONTACT_SEARCH_FILTERS] = {
  header: 'GenericGrid.error.mouse',
  illustration: 'errors/general'
};
export default class QueryErrorStateMessage extends PureComponent {
  render() {
    const {
      errorMessageType,
      header,
      subtext,
      translatedSubtext,
      objectType
    } = this.props;
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    const langConfig = errorStateMessages[errorMessageType] ?
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    errorStateMessages[errorMessageType] : errorStateMessages.generic;
    return (
      /*#__PURE__*/
      // @ts-expect-error ts-migrate(2786) FIXME: 'EmptyStateMessage' cannot be used as a JSX compon... Remove this comment to see the full error message
      _jsx(EmptyStateMessage, {
        illustration: langConfig.illustration,
        linkHref: langConfig.buttonHref,
        linkText: langConfig.buttonText,
        objectType: objectType || errorMessageType,
        onClick: langConfig.onClick || emptyFunction,
        subText: subtext || langConfig.subtext,
        titleText: header || langConfig.header,
        translatedSubtext: translatedSubtext
      })
    );
  }
}
QueryErrorStateMessage.propTypes = {
  errorMessageType: ErrorMessageType,
  header: PropTypes.string,
  objectType: AnyCrmObjectTypePropType,
  subtext: PropTypes.string,
  translatedSubtext: PropTypes.string
};
QueryErrorStateMessage.defaultProps = {
  errorMessageType: customErrorTypes.PAGE
};